import { createElement } from "react";

export function bannerVideosInitialize(sliderObject) {
    if (!sliderObject) return;
    const sliderElement = sliderObject.hostEl;
    if (!sliderElement) return;
    const allSlides = sliderElement.querySelectorAll(".banner-img");
    if (!allSlides) return;

    allSlides.forEach((slide) => {
        slide.videoID = getVideoID(slide);
        if (!slide.videoID) return;

        initPlayButton(slide, sliderObject);

    });
}

function getVideoID(slide) {
    const href = slide.querySelector("a").getAttribute("href");
    if (!href || !href.includes('vimeo.com')) return;

    const videoID = checkRegex(href, /(?:vimeo\.com\/(?:video\/)?|vimeo\.com\/)(?:channels\/\w+\/)?(\d+)/);
    return videoID;
}

function checkRegex(textToCheck, regex) {
    let matchSlices = textToCheck.match(regex);
    if (!matchSlices) return;
    return matchSlices[1];
}

function initPlayButton(slide, sliderObject) {
    const playButton = document.createElement('button');
    playButton.setAttribute('title', 'Włącz film');
    slide.appendChild(playButton);

    playButton.addEventListener('click', playVideo);
    function playVideo(event) {
        event.preventDefault();

        if (sliderObject.autoplay) {
            sliderObject.autoplay.stop();
        }

        const iframeHTML = `
                <iframe src="https://player.vimeo.com/video/${slide.videoID}?autoplay=1&amp;loop=1&amp;"
                width="1200" height="675" frameborder="0" allow="autoplay"></iframe>
            `;

        slide.insertAdjacentHTML('beforeend', iframeHTML);
        slide.classList.add("playing");
        slide.parentElement.parentElement.querySelectorAll("img").forEach(img => { img.classList.add("hide") });
    };
}

export function hideVideo(previousSlideContainer) {

    const slide = previousSlideContainer.querySelector(".banner-img");

    slide.querySelector("iframe").remove();
    slide.classList.remove("playing");
    slide.parentElement.parentElement.querySelectorAll("img").forEach(img => { img.classList.remove("hide") });
}